import {managementModels} from '@/constants/client-constants';
import {sexes} from '@/constants/global-constants';

export const getManagementModelsOptions = () => {
    let array = [];
    Object.keys(managementModels).forEach((key) => {
        array.push({
            value: key,
            text: managementModels[key]
        });
    });
    return array;
};

export const getClientSexesOptions = () => {
    let array = [];
    Object.keys(sexes).forEach((key) => {
        array.push({
            value: key,
            text: sexes[key]
        });
    });
    return array;
};